import rest from '../rest';
import auth from '../auth';

const serverUrl = process.env.VUE_APP_ROOT_API_SERVER_URL;

const tokenRequest = {
  scopes: ['api://b55d6573-6392-4c37-bbc2-cf8c6d4dfa99/User.ReadWrite'], // GBA API Scope
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getFarmLineMg() {
    try {
      const url = `${serverUrl}/FarmLineMgList/Read`;
      const options = await auth.getOptions(tokenRequest, 'GET');

      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm/Line/Mg information from server (${e.message})`)
    }
  },
  async getGenomicBleedList(farm) {
    try {
      const url = `${serverUrl}/GenomicBleedList/Read?farm=${farm}`;
      const options = await auth.getOptions(tokenRequest, 'GET');

      return await rest.call(url, options);
    } 
    catch(e) {
      throw new Error(`Unable to retrieve Genomic Bleed list for ${farm} from server (${e.message})`)
    }
  },
  async getGenomicBleed(group) {
    const url = `${serverUrl}/GenomicBleed/Read?farm=${group.farm}&line=${group.line}` + 
                `&minigeneration=${group.minigeneration}&disp=${group.disp}&hatch=${group.hatch}` + 
                `&uploadGmtDateTime=${group.uploadGmtDateTime}`;
    const options = await auth.getOptions(tokenRequest, 'GET');

    return await rest.call(url, options);
  },
  async postGenomicBleed(samples) {
    const url = `${serverUrl}/GenomicBleed/Upload`;
    const payload = JSON.stringify(samples);
    const options = await auth.getOptions(tokenRequest, 'POST', payload, true);

    return await rest.call(url, options);
  },
  async postHealthBleed(samples) {
    const url = `${serverUrl}/HealthBleed/Upload`;
    const payload = JSON.stringify(samples);
    const options = await auth.getOptions(tokenRequest, 'POST', payload, true);

    return await rest.callWithNoReturnJson(url, options);
  }
}